import React, { type ChangeEvent } from 'react';

import { Key } from '../../../../../utils';
import isNil from '../../../../../utils/isNil';
import { Input, type InputProps } from '../../../../Input';
import { useSelectRootContext } from '../../root/SelectRootContext';
import { useSelectRootFloatingContext } from '../../root/SelectRootFloatingContext';

import styles from './SelectDropdownSearchInput.module.scss';

export type SelectDropdownSearchInputProps = InputProps;

export const SelectDropdownSearchInput = (inputProps: SelectDropdownSearchInputProps) => {
    const {
        internalSearchValue,
        setInternalSearchValue,
        setOpen,
        searchContainerRef,
        selection: { selectOptionByIndex },
        options: { activeIndex, setActiveIndex, findFirstEnabledIndex }
    } = useSelectRootContext();
    const { floatingInteractions } = useSelectRootFloatingContext();
    const events = floatingInteractions.getFloatingProps() as {
        onKeyDown: (e: React.KeyboardEvent) => void;
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setInternalSearchValue(e.target.value);
        setActiveIndex(findFirstEnabledIndex());
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        e.stopPropagation();
        inputProps?.onKeyDown?.(e);

        if (e.key === Key.Enter && !isNil(activeIndex)) {
            e.preventDefault();
            selectOptionByIndex(activeIndex);
        }

        // allow list navigation (useListNavigation) to handle the event
        events.onKeyDown(e);
        if (e.key === Key.Escape) {
            setOpen(false);
        }
    };

    return (
        <div className={styles.search} ref={searchContainerRef}>
            <Input
                {...inputProps}
                value={internalSearchValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
            />
        </div>
    );
};
